import "react-app-polyfill/ie9"; // For IE 9-11 support
import "react-app-polyfill/ie11"; // For IE 11 support
import "./polyfill";
import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import { Provider } from "react-redux";
import { store } from "./_helpers/store";
import { setupInterceptor } from "./_helpers/interceptor";
import axios from 'axios';
import'./i18n';
import i18next from 'i18next';
const lang =localStorage.getItem('lang');
axios.defaults.headers.common['Accept-Lanuage']= lang;
i18next.changeLanguage(lang);

setupInterceptor();

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
